__turbopack_context__.v({
  "appliedItem": "gifts-with-product-module-scss-module__mPd4SG__appliedItem",
  "appliedList": "gifts-with-product-module-scss-module__mPd4SG__appliedList",
  "button": "gifts-with-product-module-scss-module__mPd4SG__button",
  "content": "gifts-with-product-module-scss-module__mPd4SG__content",
  "image": "gifts-with-product-module-scss-module__mPd4SG__image",
  "image__gift": "gifts-with-product-module-scss-module__mPd4SG__image__gift",
  "image__hasGift": "gifts-with-product-module-scss-module__mPd4SG__image__hasGift",
  "image__product": "gifts-with-product-module-scss-module__mPd4SG__image__product",
  "message": "gifts-with-product-module-scss-module__mPd4SG__message",
  "root": "gifts-with-product-module-scss-module__mPd4SG__root",
  "title": "gifts-with-product-module-scss-module__mPd4SG__title",
});
